<template>
  <div class="shadow" v-if="loggedIn && showUi">
    <b-navbar :type="darkMode ? 'light' : 'dark'" class="shadow" fixed="top" :class="darkMode ? 'bg-light' : 'bg-dark'" toggleable="lg" style="z-index: 1000">
      <b-navbar-brand class="custom-nav" >
        <b-row class="m-0">
          <div class="mt-1" @click="$router.push('/dashboard').catch(err => {})" >
            <img class="p-0" style="width: 200px" src="@/assets/logos/eatDoradoText.png" alt="eatDoradoLogo"/> 
          </div>
          <div v-if="company">
            <h3 class="mt-2 d-none d-md-flex ml-4 text-center" :class="!company.active ? 'text-danger' : 'text-success'">{{ !company.active ? 'offline' : 'online' }} </h3>
          </div>
          <div v-if="company">
            <b-form-checkbox
              class="mt-2 ml-3 d-none d-md-flex"
              switch size="lg"
              @change="updateCompanyDelayed"
              v-model="company.active"
              name="payment_method"
            >
            </b-form-checkbox>
          </div>
          
        </b-row>
        
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav class="mt-2 ml-auto" v-if="userInformations">
          <b-nav-item v-if="userInformations.initDone" :active="$route.name == 'Dashboard'" @click="$router.push('/dashboard').catch(err => {})"><font-awesome-icon icon="tachometer-alt" /> Dashboard</b-nav-item>
          <b-nav-item v-if="userInformations.initDone" style="position: relative" :active="$route.name == 'Bestellungen'" @click="$router.push('/orders').catch(err => {})"><font-awesome-icon  icon="mobile" /> App Bestellungen <span v-if="orders"><b-badge v-if="orders.filter(order => order.status != 'abgeholt' && order.status != 'storniert').length > 0" pill variant="danger">{{orders.filter(order => order.status != 'abgeholt' && order.status != 'storniert').length}}</b-badge></span> </b-nav-item>
          <b-nav-item v-if="userInformations.initDone" style="position: relative" :active="$route.name == 'InHouse'" @click="$router.push('/inhouse').catch(err => {})"><font-awesome-icon  icon="laptop-house" /> InHouse <span v-if="inHouseOrders"><b-badge v-if="inHouseOrders.filter(order => order.status != 'abgeschlossen').length > 0" pill variant="danger">{{inHouseOrders.filter(order => order.status != 'abgeschlossen' ).length}}</b-badge></span> </b-nav-item>
          <b-nav-item v-if="userInformations.initDone" :active="$route.name == 'Statistiken'" @click="$router.push('/statistics').catch(err => {})"><font-awesome-icon icon="chart-line" /> Auswertungen</b-nav-item>
          <b-nav-item v-if="userInformations.initDone" :active="$route.name == 'Speisekarte'" @click="$router.push('/menu').catch(err => {})"><font-awesome-icon icon="file-alt" /> Speisekarte</b-nav-item>
          <b-nav-item-dropdown right class="ml-0 ml-md-4">
            <template v-slot:button-content v-if="company">
              <em><font-awesome-icon icon="utensils" /> {{ company.title.slice(0,13) }} {{ company.title.length > 13 ? '...' : '' }}</em>
            </template>

            <b-dropdown-item v-if="userInformations.initDone" @click="$router.push('/me').catch(err => {})">Einstellungen</b-dropdown-item>
            <hr>
            <b-dropdown-item @click="$store.dispatch('logout')">Abmelden</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
      
    </b-navbar>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import { mixin as clickaway } from 'vue-clickaway';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTachometerAlt, faChartBar, faUserFriends, faClone, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'
var audio = new Audio('sounds/bell.mp3')

library.add(faTachometerAlt, faChartBar, faUserFriends, faClone, faUser)
Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  name: 'Navbar',
  mixins: [coreData, clickaway],
  components: {
    // Message
  },
  props: {

  },
  data(){
    return {
      sideBarMobile: false,
      popOverMobile: false,
      popOver: false,
      checked: false,
      sideBar: false,
    }
  },
  created() {
   
    var darkMode = localStorage.getItem('darkMode')
    if(darkMode != null){
      if(darkMode == 'true' || darkMode == true){
        this.$store.commit('darkMode', false)
      }else{
        this.$store.commit('darkMode', true)
      }
      
      this.checked = darkMode
    }
    window.addEventListener('keydown', (e) => {
      if(e.key == 'Escape'){
        this.$router.push('/home').catch(() => {})
      }

      if (e.key == 'm' && e.ctrlKey) {
        this.sideBar = !this.sideBar
      }

      if (e.key == 'p' && e.ctrlKey) {
        this.popOver = !this.popOver
      }
    });

  },
  watch: {
    darkMode(){
      this.checked = !this.darkMode
      localStorage.setItem('darkMode', !this.darkMode)
    }
  },
  computed: {
    avatarClass(){
      var avatarClass = ''
      if(this.updating){
        avatarClass += 'rotating '
      }
      if(this.darkMode){
        avatarClass += 'bg-white text-info'
      }else{
        avatarClass += 'bg-dark text-info'
      }
      return avatarClass
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    popLogin(){
      return this.$store.getters.popLogin
    },
    items(){
      return  [
          {
            text: 'Admin',
            href: '#'
          },
          {
            text: 'Manage',
            href: '#'
          },
          {
            text: 'Library',
            active: true
          }
        ]
    }
  },
  mounted(){
    if(this.darkMode){
      this.checked = false
    }
  },
  methods:{
    makeToast(append = false) {
        this.toastCount++
        this.$bvToast.toast(`Eine neue Bestellung ist eingetroffen!`, {
          title: 'Neue Bestellung!',
          autoHideDelay: 5000,
          appendToast: append
        })
        audio.play()
      },
    playSound(){
      audio.play()
    },
    changeTheme(){
      this.$store.commit('darkMode', this.checked)
    },
    toggleProfile(){
      if(this.popOver){
        this.popOver = false
      }
    },
    toggleSidebar(){
      if(this.sideBar){
        this.sideBar = false
      }
    },
    toggleProfileMobile(){
      if(this.popOverMobile){
        this.popOverMobile = false
      }
    },
    toggleSidebarMobile(){
      if(this.sideBarMobile){
        this.sideBarMobile = false
      }
    }
  }
}
</script>

<style>
  .modal-body {
    background-color: rgba(0,0,0,.0001) !important;
    border: none !important;
  }
  .modal-content {
    background-color: rgba(0,0,0,.0001) !important;
    border: none !important;
  }
</style>